var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3939_37414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9464 11.257C15.1519 11.257 16.9398 9.39138 16.9398 7.09004C16.9398 4.7887 15.1519 2.9231 12.9464 2.9231C10.741 2.9231 8.95312 4.7887 8.95312 7.09004C8.95312 9.39138 10.741 11.257 12.9464 11.257Z",
    fill: "#FFF8E8",
    stroke: "#333333",
    strokeWidth: 2.08347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9309 24.2786C21.9309 19.1006 17.9082 14.3821 12.9459 14.3821C7.98366 14.3821 3.96094 19.1006 3.96094 24.2786",
    fill: "#FFF8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9309 24.2786C21.9309 19.1006 17.9082 14.3821 12.9459 14.3821C7.98366 14.3821 3.96094 19.1006 3.96094 24.2786C6.95593 25.3203 21.9309 24.6258 21.9309 24.2786Z",
    stroke: "#333333",
    strokeWidth: 2.08347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3939_37414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9599,
    height: 25.0017,
    fill: "white",
    transform: "translate(0.966797 0.8396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0538a46dcdbd186196e36bef7075b6b5.svg";
export { ForwardRef as ReactComponent };